/* eslint-disable prefer-spread, prefer-rest-params, react/prop-types */
import React from 'react'
import BaseTimeAgo from 'react-timeago'
import defaultFormatter from 'react-timeago/lib/defaultFormatter'

const WEEKS_IN_MONTH = 4.34812141

export const units = {
  second: 's',
  minute: 'm',
  hour: 'h',
  day: 'd',
  week: 'w',
  month: 'mo',
  year: 'y',
}

export function longDateFormatter(value, unit) {
  if ((value === 1 && unit === 'day') || (value === 24 && unit === 'hour'))
    return 'Yesterday'
  return unit === 'second' ? 'Now' : defaultFormatter.apply(null, arguments)
}

export function shortDateFormatter(value, unit, sufix, showSufix) {
  if (unit === 'second') return 'Now'

  let formattedDate
  if (unit === 'month') {
    formattedDate = `${Math.round(value * WEEKS_IN_MONTH)}${units.week}`
  } else {
    formattedDate = `${value}${units[unit]}`
  }

  if (showSufix) {
    return `${formattedDate} ${sufix}`
  }
  return `${formattedDate}`
}

const TimeAgo = ({
  date,
  short = false,
  showShortDateSufix = false,
  ...props
}) => (
  <BaseTimeAgo
    date={date}
    title={new Date(date).toLocaleString()}
    formatter={
      short
        ? (value, unit, sufix) =>
            shortDateFormatter(value, unit, sufix, showShortDateSufix)
        : longDateFormatter
    }
    {...props}
  />
)

export default TimeAgo
